import { FormEvent, useState } from "react";
import { supabase } from "../lib/supabase";

type Mode = "signin" | "signup";

export default function Login() {
  const [mode, setMode] = useState<Mode>("signin");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    setMessage("");

    if (mode === "signin") {
      const { error: signInError } = await supabase.auth.signInWithPassword({
        email: email.trim(),
        password,
      });

      if (signInError) setError(signInError.message);
      setBusy(false);
      return;
    }

    const { data, error: signUpError } = await supabase.auth.signUp({
      email: email.trim(),
      password,
      options: {
        data: {
          full_name: fullName.trim() || null,
        },
      },
    });

    if (signUpError) {
      setError(signUpError.message);
    } else if (!data.session) {
      setMessage(
        "Conta criada. Confirme o email recebido e depois entre. O acesso à Base L37 ficará pendente até ser ativado.",
      );
    } else {
      setMessage(
        "Conta criada. O acesso à Base L37 ficará pendente até ser ativado.",
      );
    }

    setBusy(false);
  }

  function changeMode(nextMode: Mode) {
    setMode(nextMode);
    setError("");
    setMessage("");
  }

  return (
    <main className="auth-layout">
      <section className="auth-brand">
        <div className="brand-mark">L37</div>
        <p className="eyebrow">Base interna</p>
        <h1>Preços & Orçamentação</h1>
        <p className="muted auth-copy">
          Pesquisa histórica de preços secos, catálogo normalizado e apoio à
          preparação de propostas da L37.
        </p>
      </section>

      <section className="auth-card card">
        <div>
          <p className="eyebrow">Acesso reservado</p>
          <h2>{mode === "signin" ? "Entrar" : "Criar conta"}</h2>
          <p className="muted">
            {mode === "signin"
              ? "Utilize a conta autorizada para a aplicação L37 Preços."
              : "A nova conta fica sem acesso aos dados até ser ativada por um administrador."}
          </p>
        </div>

        <form onSubmit={submit} className="stack-lg">
          {mode === "signup" ? (
            <label>
              <span>Nome</span>
              <input
                autoComplete="name"
                type="text"
                value={fullName}
                onChange={(event) => setFullName(event.target.value)}
              />
            </label>
          ) : null}

          <label>
            <span>Email</span>
            <input
              autoComplete="email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </label>

          <label>
            <span>Palavra-passe</span>
            <input
              autoComplete={mode === "signin" ? "current-password" : "new-password"}
              type="password"
              minLength={8}
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </label>

          {error ? <div className="alert alert-error">{error}</div> : null}
          {message ? <div className="alert alert-success">{message}</div> : null}

          <button className="button button-primary" type="submit" disabled={busy}>
            {busy
              ? mode === "signin"
                ? "A entrar…"
                : "A criar…"
              : mode === "signin"
                ? "Entrar"
                : "Criar conta"}
          </button>
        </form>

        <div className="auth-switch">
          <span className="muted">
            {mode === "signin" ? "Ainda não tem conta?" : "Já tem conta?"}
          </span>
          <button
            className="text-action"
            type="button"
            onClick={() => changeMode(mode === "signin" ? "signup" : "signin")}
          >
            {mode === "signin" ? "Criar acesso" : "Voltar ao login"}
          </button>
        </div>
      </section>
    </main>
  );
}
